import { weekOf } from '../../shared/dates';
import type { OutreachLeadStatus } from '../../shared/types';

export type OutreachMobileAction =
  | { kind: 'status'; label: string; status: OutreachLeadStatus }
  | { kind: 'promote'; label: string };

export function outreachNextAction(status: OutreachLeadStatus): OutreachMobileAction {
  switch (status) {
    case 'new': return { kind: 'status', label: 'Reached out', status: 'reached_out' };
    case 'reached_out': return { kind: 'status', label: 'Followup', status: 'followup' };
    case 'followup': return { kind: 'status', label: 'Replied', status: 'replied' };
    case 'replied': return { kind: 'promote', label: 'Promote' };
    case 'closed': return { kind: 'status', label: 'Reopen', status: 'reached_out' };
  }
}

export function outreachHeaderCount(shown: number, total: number): string {
  return `${shown} OF ${total}`;
}

export function outreachWeekLine(runDate: string | null): string {
  if (!runDate) return 'COLD LEADS';
  const monday = weekOf(runDate).start;
  const [, month, day] = monday.split('-').map(Number);
  const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  return `COLD LEADS · WEEK OF ${day} ${months[month - 1]}`;
}

export function outreachRank(rank: number): string {
  return String(rank).padStart(2, '0');
}
